import React from 'react'
import { latLng, Marker, Popup, Tooltip } from '@fareye/ui'
import { Span } from '@fareye/ui'
import FieldValue from './FieldValue'
import { displayTime } from '../../../utility/function'
import { useTranslation } from '@fareye/common'

export function ConsignerMarker({ icon, data, selected, stopData }: any) {
  const { t } = useTranslation()
  const { consignerLong, consignerLat, status } = data
  const { std, atd } = stopData
  const [tempState, setState] = React.useState(0)

  const { locationName: name, city } = data?.startLocation || {}
  function openPopup(marker: any) {
    if (marker && selected) {
      marker.leafletElement.openPopup()
    }
    if (marker && !selected) {
      marker.leafletElement.closePopup()
    }
  }

  return (
    <Marker
      position={latLng(consignerLat, consignerLong)}
      icon={icon}
      eventHandlers={{
        click: () => setState(tempState + 1)
      }}
    >
      <Tooltip direction="top" permanent offset={[10, -10]}>
        <strong>{t('Origin')}</strong> : {name}
      </Tooltip>
      <Popup minWidth={149}>
        <Span variant="h6" style={{ marginBottom: 4 }}>
          {city}
        </Span>
        <Span variant="ellipsis secondary" style={{ marginBottom: 10 }}>
          {name}
        </Span>
        {status && (
          <FieldValue
            style={{ marginBottom: 15 }}
            labelStyle={{ color: '#212121', fontWeight: 500 }}
            label={`${t('Status')}${':'} `}
            value={t(status) || '-'}
          />
        )}
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: '#212121' }}
          label={t('STD')}
          value={displayTime(std)}
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: '#212121' }}
          label={t('ATD')}
          value={displayTime(atd)}
        />
      </Popup>
    </Marker>
  )
}
